import { AppState, WindowState } from '@mode/legacy/types-app-state';
import { ReducerTree } from '@mode/legacy/util-domain';
import { Actions } from '../../actions/';
import { WindowActions } from '../../actions/window.actions';

export const initialWindowState: WindowState = {
  isFullscreen: false,
};

function isFullscreenReducer(state = initialWindowState.isFullscreen, action: Actions): WindowState['isFullscreen'] {
  switch (action.type) {
    case WindowActions.Type.EnterFullscreenSuccess:
      return true;
    case WindowActions.Type.EnterFullscreenFailure: // falls through
    case WindowActions.Type.ExitFullscreen:
      return false;
  }

  return state;
}

export const TransientWindowReducer: ReducerTree<AppState, WindowState, Actions> = {
  isFullscreen: isFullscreenReducer,
};
